import { connect } from 'react-redux';
import { actions } from '../../../../redux/modules/gestion_proyecto/presupuesto';
import Presupuesto from './Presupuesto';

const ms2p = (state) => {
  return {
    ...state.proyecto_presupuesto,
  };
};

const md2p = { ...actions };

export default connect(ms2p, md2p)(Presupuesto);
